export default "__VITE_ASSET__165eab40__"